var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"mt-5 mb-5"},[_c('h1',{staticClass:"fs-4 font-weight-bold mb-4"},[_vm._v("Scanner")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }